class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    // Escape belongs to FocusLayer. The layer root is the <details> itself, so
    // nothing is nested for Escape to defer to and this modal is dismissed directly;
    // a facet group or dropdown opened inside it is nested, and collapses first.
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    this.detailsContainer.getBoundingClientRect();

    // Contained but not modal: third-party autocomplete (constructor-autocomplete)
    // may render its results outside this subtree, and `inert` would hide them.
    FocusLayer.push(this.detailsContainer, {
      contain: true,
      modal: false,
      trigger: this.summaryToggle,
      initialFocus: this.detailsContainer.querySelector('input:not([type="hidden"])'),
      onDismiss: () => this.close(),
    });
  }

  close(focusToggle = true) {
    FocusLayer.pop(this.detailsContainer, { returnFocus: focusToggle ? this.summaryToggle : null });
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden', 'is_fixed');
  }
}

customElements.define('details-modal', DetailsModal);
